export const columnsDataPurchaseInvoices = [
  { Header: 'Número', accessor: 'invoiceId' },
  { Header: 'Proveedor', accessor: 'provider.name' },
  { Header: 'Fecha', accessor: 'date' },
  { Header: 'Vencimiento', accessor: 'expirationDate' },
  { Header: 'Total', accessor: 'totalAmount', enableSorting: true },
  { Header: 'Estado', accessor: 'status' },
];
